// Scene registry
// To add a new scene: import its factory and add it to REGISTRY.
// The key becomes the scene name shown in the UI and stored in presets.

import { createOscillationScene } from "./oscillation";
import { createVennScene } from "./venn";

const REGISTRY = {
  Oscillation: createOscillationScene,
  Venn:        createVennScene,
};

// Select-input options derived from the registry — stays in sync automatically
export const SCENE_OPTIONS = Object.keys(REGISTRY).map((name) => ({ name }));

// Instantiate a scene by name, falling back to Oscillation for unknown names
export function createScene(name, w, h) {
  const factory = REGISTRY[name] ?? REGISTRY.Oscillation;
  return factory(w, h);
}
